/*

class to generate code

https://www.hl7.org/fhir/datatypes.html#Code

{
  "code" : "<code>", // Symbol in syntax defined by the system
  "display" : "<string>", // Representation defined by the system
  "system" : "<uri>", // Identity of the terminology system
  "version" : "<string>", // Version of the system - if relevant
  "userSelected" : <boolean> // If this code was chosen directly by the user
}

*/
// Import libraries
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');

// Create schema
const schema = {
  code: Joi.string().required(),
  display: Joi.string().required(),
  system: Joi.string().optional(),
  version: Joi.string().optional(),
  userSelected: Joi.boolean().optional(),
};

// Define class
class Code {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Code = Code;
exports.codeSchema = schema;